(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("echarts"), require("Vuex"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "echarts", "Vuex", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["brokenSubApp"] = factory(require("axios"), require("echarts"), require("Vuex"), require("Vue"));
	else
		root["brokenSubApp"] = factory(root["axios"], root["echarts"], root["Vuex"], root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_OMN4__, __WEBPACK_EXTERNAL_MODULE_Pg0u__, __WEBPACK_EXTERNAL_MODULE_SJI6__, __WEBPACK_EXTERNAL_MODULE_lRwf__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition